var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper__container"},[_c('ul',{staticClass:"stepper stepper__header"},_vm._l((_vm.headers),function(header,index){return _c('li',{key:header},[_c('h1',{class:[
          'stepper__title',
            _vm.shouldApplyTitleClass(index)
            ? 'stepper__title--active'
            : 'stepper__title--disabled'
        ]},[_vm._v("\n        "+_vm._s(header)+"\n      ")])])}),0),_vm._v(" "),_c('ul',{staticClass:"stepper stepper__lines"},_vm._l((_vm.numberOfSteps),function(step){return _c('li',{key:step},[_c('div',{class:[
          'stepper__line',
          _vm.currentStep >= step
            ? 'stepper__line--active'
            : 'stepper__line--disabled'
        ]})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }